export function identifyUser(user) {
  if (window.DD_RUM_INIT) {
    window.DD_RUM_INIT(() => window.DD_RUM?.setUser?.({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.emailAddress,
      companyName: user.Company.name,
      companyCode: user.Company.code,
      companyId: user.companyId,
    }));
  }
}

export function reportError(...args) {
  console.error(...args);
}
